import styles from './PanelColumn.module.scss';

export default function PanelColumnComponent({ length, size, visible, children, sibling }) {

    const classNames = sibling ? styles.redlPanelColumnSibling : styles.redlPanelColumn;
    const lengthStyles = {
        1: styles.redlPanelColumnLength1,
        2: styles.redlPanelColumnLength2,
        3: styles.redlPanelColumnLength3,
      };
    const classNamesLength = lengthStyles[length] || null;
      

    return (
        <div className={`${classNames} ${size ? styles[`visible-${size}`] : ''} ${classNamesLength}`} >
            {visible ? children : null}
        </div>
    );
}